import { Component, OnInit, AfterViewInit } from '@angular/core';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
  FormGroup,
  FormBuilder,
  FormArray,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {
  StakeholderReferenceDto,
  StakeholderDto,
  CountryDto,
  StateDto,
  LgaDto,
  CommunityDto,
  EngagementDto,
} from '@cradua/data';
import { Observable, Subscription } from 'rxjs';

import { StakeholderReferenceFacade } from './../../../../../stakeholderreference/src/lib/states/+stakeholderreference/stakeholderreference.facade';
import { switchMap } from 'rxjs/operators';

import Swal from 'sweetalert2';
import { StakeholderFacade } from '../../states/+stakeholder/stakeholder.facade';

import { CountryFacade } from './../../../../../epims-references/src/lib/states/+country/country.facade';

import { AnchorEPIMSFacade } from './../../../../../anchorepimsgates/src/lib/states/+anchorepimsgates/anchorepimsgates.facade';

import { Guid } from 'guid-typescript';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

interface Food {
  value: string;
  viewValue: string;
}
interface ReferenceType {
  value: string;
  viewValue: string;
}
interface BusinessThemes {
  name: string;
  ischecked: boolean;
  id: string;
}

class DeletedData {
  id: string;
  type: string;
}

@Component({
  selector: 'mrsoftapps-stakeholder-container',
  templateUrl: './stakeholder-container.component.html',
  styleUrls: ['./stakeholder-container.component.css'],
})
export class StakeholderContainerComponent implements OnInit, AfterViewInit {
  panelOpenState = false;
  stakeholderForm: FormGroup;
  stakeholderEngagementForm: FormGroup;
  politicalparties$: Observable<StakeholderReferenceDto[]>;
  politicalparties: StakeholderReferenceDto[] = [];
  contacttypes$: Observable<StakeholderReferenceDto[]>;
  contacttypes: StakeholderReferenceDto[] = [];

  titles$: Observable<StakeholderReferenceDto[]>;
  stakeholders$: Observable<StakeholderDto[]>;
  stakeholders: StakeholderDto[];
  filteredstakeholders: StakeholderDto[];
  titles: StakeholderReferenceDto[] = [];
  partysubscription: Subscription;
  filteredDelete: Array<any> = [];
  stakeholderId: string;
  stakeholderEngagementId: string;
  searchvalue: string;
  searchEngagementvalue: string;
  displayFrom: boolean = false;
  isNew: boolean = true;
  isNewEngagement: boolean = true;
  isUpdated: boolean = false;
  valueChangedCounter: number = 0;
  countries$: Observable<CountryDto[]>;
  countries: Array<CountryDto>;
  states$: Observable<StateDto[]>;
  states: StateDto[];
  lgas$: Observable<LgaDto[]>;
  lgas: LgaDto[];
  communities$: Observable<CommunityDto[]>;
  communities: CommunityDto[];
  businessThemes: BusinessThemes[] = [];

  socialmediatypes$: Observable<StakeholderReferenceDto[]>;
  socialmediatypes: StakeholderReferenceDto[] = [];

  organizations$: Observable<StakeholderReferenceDto[]>;
  organizations: StakeholderReferenceDto[] = [];

  areaofinterests$: Observable<StakeholderReferenceDto[]>;
  areaofinterests: StakeholderReferenceDto[] = [];

  clubs$: Observable<StakeholderReferenceDto[]>;
  clubs: StakeholderReferenceDto[] = [];
  propertys: StakeholderReferenceDto[] = [];

  companies: StakeholderReferenceDto[] = [];
  lineOfBusinesses: StakeholderReferenceDto[] = [];
  engagementTypes: StakeholderReferenceDto[] = [];
  engagementCategories: StakeholderReferenceDto[] = [];
  engagementDrivers: StakeholderReferenceDto[] = [];

  deletedSubItems: DeletedData[] = [];

  foods: Food[] = [{ value: 'NoGroup', viewValue: 'No Grouping' }];

  epimsgatesdata$: Observable<any[]>;

  engagements: EngagementDto[];
  filteredengagements: EngagementDto[];
  isShowEngagementForm = false;
  engagementModule: string = 'Engagement';
  engagementModuleSpecificId: string = '';
  SubmitIsTriggerByparent: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private stakeholderreferenceFacade: StakeholderReferenceFacade,
    private stakeholderFacade: StakeholderFacade,
    private countryFacade: CountryFacade,
    private epimsGateFacade: AnchorEPIMSFacade
  ) {}

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  matcher = new MyErrorStateMatcher();

  contactTypes: ReferenceType[] = [
    { value: 'Email', viewValue: 'Email' },
    { value: 'Phone', viewValue: 'Phone' },
  ];

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
  }

  ngOnInit() {
    this.loadAllInitData();

    this.initStakeholderForm();

    this.initStakeholderEngagementForm();

    this.setShadowClasses();

    this.onChanges();

    //this.isLoadingStakeholderReference$ = this.stakeholderreferenceFacade.isLoadingByTypeStakeholderReference("Language",this.selectedCountryId, this.selectedStakeholderGroupId);
  }

  loadAllInitData() {
    this.stakeholderFacade.loadStakeholder.subscribe((data) => {
      this.stakeholders = data;
    });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('ContactType', undefined, undefined)
      .subscribe((data) => {
        // console.log("Data Contact Type ", data );

        if (this.contacttypes.length === 0) {
          this.contacttypes = data.filter((n) => n.Type === 'ContactType');
          // this.contacttypes = data.map((item) => {
          // 	return {
          // 		id: item.id,
          //     Desc: item.Desc,
          //     Address: item.Address,
          //     Location: item.Location,
          //     Name: item.Name,
          //     SubscriberId: item.SubscriberId,
          //     SiteId: item.SiteId,
          //     SectorId: item.SectorId,
          //     StakeholderGroupId: item.StakeholderGroupId,

          // 	};
          // });
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('PoliticalParty', undefined, undefined)
      .subscribe((data) => {
        if (this.politicalparties.length === 0) {
          this.politicalparties = data.filter(
            (n) => n.Type === 'PoliticalParty'
          );
        }

        this.countries$ = this.countryFacade.loadCountry;

        this.countryFacade.loadCountry.subscribe((data) => {
          this.countries = data;
        });
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('SocialMediaType', undefined, undefined)
      .subscribe((data) => {
        if (this.socialmediatypes.length === 0) {
          this.socialmediatypes = data.filter(
            (n) => n.Type === 'SocialMediaType'
          );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('Title', undefined, undefined)
      .subscribe((data) => {
        // console.log("Data Title for Political party ", this.politicalparties );

        if (this.titles.length === 0) {
          this.titles = data.filter((n) => n.Type === 'Title');
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('Organization', 'All', undefined)
      .subscribe((data) => {
        // console.log("Data Contact Type ", data );
        if (this.organizations.length === 0) {
          this.organizations = data.filter((n) => n.Type === 'Organization');

          console.log('Organization Data ', data);
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('AreaOfInterest', undefined, undefined)
      .subscribe((data) => {
        // console.log("Data Contact Type ", data );
        if (this.areaofinterests.length === 0) {
          this.areaofinterests = data.filter(
            (n) => n.Type === 'AreaOfInterest'
          );
          for (let area of this.areaofinterests) {
            this.businessThemes.push({
              name: area.Name,
              ischecked: false,
              id: area.id,
            });
          }

          // console.log("Organization Data ",data );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('Club', undefined, 'All')
      .subscribe((data) => {
        // console.log("Data Contact Type ", data );
        if (this.clubs.length === 0) {
          this.clubs = data.filter((n) => n.Type === 'Club');

          // console.log("Organization Data ",data );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('Property', undefined, 'All')
      .subscribe((data) => {
        // console.log("Data Contact Type ", data );
        if (this.propertys.length === 0) {
          this.propertys = data.filter((n) => n.Type === 'Property');

          // console.log("Organization Data ",data );
        }
      });

    this.epimsGateFacade.loadEPIMSGate('Engagement').subscribe(
      (data) => {
        this.engagements = data;

        console.log('Got Data from EPIMS gate ', this.engagements);
      },
      (error) => {
        console.log('Got Data from EPIMS gate error ', error);
      }
    );

    this.epimsgatesdata$ = this.epimsGateFacade.loadEPIMSGate('Language');

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('LineOfBusiness', undefined, undefined)
      .subscribe((data) => {
        if (this.lineOfBusinesses.length === 0) {
          this.lineOfBusinesses = data.filter(
            (n) => n.Type === 'LineOfBusiness'
          );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('EngagementType', undefined, undefined)
      .subscribe((data) => {
        if (this.engagementTypes.length === 0) {
          this.engagementTypes = data.filter(
            (n) => n.Type === 'EngagementType'
          );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference(
        'EngagementCategory',
        undefined,
        undefined
      )
      .subscribe((data) => {
        if (this.engagementCategories.length === 0) {
          this.engagementCategories = data.filter(
            (n) => n.Type === 'EngagementCategory'
          );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('EngagementDriver', undefined, undefined)
      .subscribe((data) => {
        if (this.engagementDrivers.length === 0) {
          this.engagementDrivers = data.filter(
            (n) => n.Type === 'EngagementDriver'
          );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference('Company', undefined, undefined)
      .subscribe((data) => {
        if (this.companies.length === 0) {
          this.companies = data.filter((n) => n.Type === 'Company');

          // console.log("Company Data ", this.companies);
        }
      });
  }

  addNewStakeholder() {
    this.displayFrom = true;
    this.isNew = true;
    this.isUpdated = false;

    this.initStakeholderForm();
    this.filteredstakeholders = [];
    this.setShadowClasses();
  }

  addNewEngagement() {
    this.isNewEngagement = true;
    this.isShowEngagementForm = true;

    this.initStakeholderEngagementForm();
    this.filteredengagements = [];
    //this.setShadowClasses();
  }

  initStakeholderForm() {
    this.stakeholderId = Guid.create().toString();

    this.stakeholderForm = this.formBuilder.group({
      id: [this.stakeholderId],
      StakeholderId: [this.stakeholderId],

      Surname: ['', Validators.required],
      Firstname: [''],
      Middlename: [''],
      Fullname: [''],
      TitleId: [''],
      StakeholderDesc: [''],
      LevelOfInfluence: [0],
      LevelOfInterest: [0],
      LevelOfImpact: [0],
      RelationshipRating: [0],
      DOB: ['3/3/1994'],
      DOBShort: [''],
      CreatedById: [''],
      SubscriberId: [''],
      SiteId: [''],
      ObjPartnershipDesc: [''],
      ObjPolicyDevDesc: [''],
      ObjPRDesc: [''],
      ObjSomeoneToBlameDesc: [''],
      ModifiedById: [''],
      modifiedBy: [''],
      PoliticalPartyId: [''],
      DecisionInfluence: [''],
      Gender: [''],
      OrganizationHistory: [''],
      AgeBracket: [''],

      stakeholderComplaints: this.formBuilder.array([]),
      stakeholderAreaOfInterests: this.formBuilder.array([]),
      stakeholderClubs: this.formBuilder.array([]),
      stakeholderContacts: this.formBuilder.array([]),

      stakeholderInteractions: this.formBuilder.array([]),
      stakeholderLanguages: this.formBuilder.array([]),
      stakeholderMappings: this.formBuilder.array([]),
      stakeholderOrganizations: this.formBuilder.array([]),
      stakeholderPostalAddresses: this.formBuilder.array([]),
      stakeholderPropertys: this.formBuilder.array([]),
      stakeholderSocialMedias: this.formBuilder.array([]),
      stakeholderTasks: this.formBuilder.array([]),
    });
  }

  initStakeholderEngagementForm() {
    this.stakeholderEngagementId = Guid.create().toString();

    this.engagementModuleSpecificId = this.stakeholderEngagementId;

    this.stakeholderEngagementForm = this.formBuilder.group({
      id: [this.stakeholderEngagementId],
      EngagementId: [this.stakeholderEngagementId],

      EngagementTitle: ['', Validators.required],
      EngagementProposedDate: ['3/3/1994'],
      EngagementDate: ['3/3/1994'],
      EngagementObjective: [''],
      EngagementDescription: [''],
      EngagementValueAtStake: [''],
      EngagementTypeId: [''],
      EngagementCategoryId: [''],
      EngagementDriverId: [''],
      EngagementLineOfBusinessId: [''],
      EngagementGroupId: [''],
      EngagementCompanyId: [''],
      EngagementParentId: [''],
      SubscriberId: [''],
      SiteId: [''],
      ResolutionReached: [''],

      engagementStakeholders: this.formBuilder.array([]),
      engagementThirdPartyReps: this.formBuilder.array([]),
      engagementBusinessThemes: this.formBuilder.array([]),
      engagementResponsePersons: this.formBuilder.array([]),
    });
  }

  // method to add Country
  addStakeholderContact() {
    this.displayFrom = true;

    let contactGenId = Guid.create().toString();

    const control = this.stakeholderForm.controls
      .stakeholderContacts as FormArray;
    control.insert(
      0,
      this.formBuilder.group({
        StakeholderContactValue: ['', Validators.required],
        ContactTypeId: ['', Validators.required],
        ContactTypeName: [''],
        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [this.stakeholderId],
        StakeholderContactId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  deleteStakeholderContact(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderForm.controls
          .stakeholderContacts as FormArray;
        control.removeAt(index);

        console.log('Deleted Id ', value);

        this.deletedSubItems.push({ id: value.id, type: 'Contact' });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  addStakeholderPostalAddress() {
    let contactGenId = Guid.create().toString();

    const control2 = this.stakeholderForm.controls
      .stakeholderPostalAddresses as FormArray;
    control2.insert(
      0,
      this.formBuilder.group({
        StakeholderPostalAddressFirst: ['', Validators.required],
        StakeholderPostalAddressSecond: [''],
        CityId: [''],
        PostalCode: [''],
        StateId: [''],
        CountryId: [''],
        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [this.stakeholderId],
        StakeholderPostalAddressId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  addStakeholderSocialMedia() {
    let contactGenId = Guid.create().toString();

    const control3 = this.stakeholderForm.controls
      .stakeholderSocialMedias as FormArray;
    control3.insert(
      0,
      this.formBuilder.group({
        StakeholderSocialMediaValue: ['', Validators.required],
        SocialMediaTypeId: ['', Validators.required],
        ModifierMethod: '',

        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [this.stakeholderId],
        StakeholderSocialMediaId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  addStakeholderOrganization() {
    let contactGenId = Guid.create().toString();

    const controlorg = this.stakeholderForm.controls
      .stakeholderOrganizations as FormArray;
    controlorg.insert(
      0,
      this.formBuilder.group({
        StakeholderOrganizationDesc: ['', Validators.required],
        OrganizationId: ['', Validators.required],
        PositionId: '',
        PositionName: '',
        DivisionId: '',
        DivisionName: '',
        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [this.stakeholderId],
        StakeholderOrganizationId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  addStakeholderAreaOfInterest() {
    let contactGenId = Guid.create().toString();

    const controlareaofinterest = this.stakeholderForm.controls
      .stakeholderAreaOfInterests as FormArray;
    controlareaofinterest.insert(
      0,
      this.formBuilder.group({
        AreaOfInterestId: ['', Validators.required],

        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [this.stakeholderId],
        StakeholderAreaOfInterestId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  addStakeholderClubs() {
    let contactGenId = Guid.create().toString();

    const controlclubs = this.stakeholderForm.controls
      .stakeholderClubs as FormArray;
    controlclubs.insert(
      0,
      this.formBuilder.group({
        ClubId: ['', Validators.required],

        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [this.stakeholderId],
        StakeholderClubId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  addStakeholderProperty() {
    let contactGenId = Guid.create().toString();

    const controlpropertys = this.stakeholderForm.controls
      .stakeholderPropertys as FormArray;
    controlpropertys.insert(
      0,
      this.formBuilder.group({
        PropertyId: ['', Validators.required],

        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [this.stakeholderId],
        StakeholderPropertyId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  addEngagementReps() {
    let contactGenId = Guid.create().toString();

    const controlpropertys = this.stakeholderEngagementForm.controls
      .engagementThirdPartyReps as FormArray;
    controlpropertys.insert(
      0,
      this.formBuilder.group({
        EngagementThirdPartyRepName: ['', Validators.required],
        EngagementThirdPartyRepPhone: [''],
        EngagementThirdPartyRepEmail: [''],
        EngagementThirdPartyRepRemarks: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        EngagementId: [this.stakeholderEngagementId],
        EngagementThirdPartyRepId: [contactGenId],
        id: contactGenId,
      })
    );
  }

  deleteEngagementReps(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderEngagementForm.controls
          .engagementThirdPartyReps as FormArray;
        control.removeAt(index);

        this.deletedSubItems.push({
          id: value.id,
          type: 'EngagementThirdPartyRep',
        });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  deleteStakeholderOrganization(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderForm.controls
          .stakeholderOrganizations as FormArray;
        control.removeAt(index);

        this.deletedSubItems.push({ id: value.id, type: 'Organization' });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  deleteStakeholderPostalAddress(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderForm.controls
          .stakeholderPostalAddresses as FormArray;
        control.removeAt(index);
        this.deletedSubItems.push({ id: value.id, type: 'Address' });
        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  deleteStakeholderSocialMedia(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderForm.controls
          .stakeholderSocialMedias as FormArray;
        control.removeAt(index);
        this.deletedSubItems.push({ id: value.id, type: 'SocialMedia' });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  deleteStakeholderAreaOfInterest(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderForm.controls
          .deleteStakeholderAreaOfInterest as FormArray;
        control.removeAt(index);

        this.deletedSubItems.push({ id: value.id, type: 'Interest' });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  deleteStakeholderClubs(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderForm.controls
          .stakeholderClubs as FormArray;
        control.removeAt(index);
        this.deletedSubItems.push({ id: value.id, type: 'Club' });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  deleteStakeholderPropertys(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderForm.controls
          .stakeholderPropertys as FormArray;
        control.removeAt(index);

        this.deletedSubItems.push({ id: value.id, type: 'Property' });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  deleteEngagementStakeholder(event: Event, index, value) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderEngagementForm.controls
          .engagementStakeholders as FormArray;
        control.removeAt(index);

        this.deletedSubItems.push({
          id: value.id,
          type: 'EngagementStakeholder',
        });

        Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  OnSubmit() {
    let displayText = '';
    let yestext = '';
    let notext = '';
    if (this.isNew) {
      displayText = 'You want to profile this stakeholder?';
      yestext = 'Yes, Create it!';
      notext = 'No, Do not Create it';
    } else {
      displayText = 'You want to update this stakeholder?';
      yestext = 'Yes, Update it!';
      notext = 'No, Do not Update it';
    }
    Swal.fire({
      title: 'Are you sure?',
      text: displayText,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: yestext,
      cancelButtonText: notext,
    }).then((result) => {
      if (result.value) {
        console.log('Submiting ', this.stakeholderForm.value);
        if (this.isNew) {
          this.stakeholderFacade.addStakeholder(this.stakeholderForm.value);
        } else {
          this.stakeholderFacade.updateStakeholder(
            this.stakeholderForm.value,
            this.deletedSubItems
          );
        }

        this.initStakeholderForm();
        if (this.isNew) {
          Swal.fire(
            'Success!',
            'Stakeholder was created successfully.',
            'success'
          );
        } else {
          Swal.fire(
            'Success!',
            'Stakeholder was updated successfully.',
            'success'
          );
        }

        this.isNew = true;
        this.isUpdated = false;

        this.setShadowClasses();

        this.SubmitIsTriggerByparent = true;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  OnSubmitEngagement() {
    let displayText = '';
    let yestext = '';
    let notext = '';
    if (this.isNew) {
      displayText = 'You want to create engagement?';
      yestext = 'Yes, Create it!';
      notext = 'No, Do not Create it';
    } else {
      displayText = 'You want to update this engagement?';
      yestext = 'Yes, Update it!';
      notext = 'No, Do not Update it';
    }
    Swal.fire({
      title: 'Are you sure?',
      text: displayText,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: yestext,
      cancelButtonText: notext,
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderEngagementForm.controls
          .engagementBusinessThemes as FormArray;
        console.log('Contents of Business Theme  ', this.businessThemes);
        for (let theme of this.businessThemes) {
          //check if Business Theme exist in the

          let isExisting = this.stakeholderEngagementForm.value.engagementBusinessThemes.find(
            (n) => n.BusinessThemeId === theme.id
          );

          console.log(' Is Existing Data theme ', theme.ischecked, isExisting);
          if (theme.ischecked) {
            if (isExisting === undefined) {
              console.log(' Is Existing Data ', isExisting);
              let contactGenId = Guid.create().toString();
              control.insert(
                0,
                this.formBuilder.group({
                  CreatedById: [''],
                  ModifiedById: [''],
                  SubscriberId: [''],
                  SiteId: [''],
                  BusinessThemeId: [theme.id],
                  EngagementBusinessThemeId: [contactGenId],
                  EngagementId: this.stakeholderEngagementForm.value
                    .EngagementId,
                  id: contactGenId,
                })
              );
            }
          } else {
            if (isExisting !== undefined) {
              //Remove from the Area
              // Insert in deleted Array
              this.deletedSubItems.push({
                id: theme.id,
                type: 'EngagementBusinessTheme',
              });
            }
          }
        }

        console.log('Submiting ', this.stakeholderEngagementForm.value);

        //return;
        if (this.isNewEngagement) {
          this.epimsGateFacade.add(
            'Engagement',
            this.stakeholderEngagementForm.value
          );
        } else {
          this.epimsGateFacade.update(
            'Engagement',
            this.stakeholderEngagementForm.value,
            this.deletedSubItems
          );
        }
        this.stakeholderEngagementForm.reset();
        this.initStakeholderForm();
        if (this.isNewEngagement) {
          Swal.fire(
            'Success!',
            'Engagement was created successfully.',
            'success'
          );
        } else {
          Swal.fire(
            'Success!',
            'Engagement was updated successfully.',
            'success'
          );
        }

        this.isNew = true;
        this.isUpdated = false;

        this.setShadowClasses();

        this.SubmitIsTriggerByparent = true;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //Swal.fire('Cancelled', 'Your record is safe :)', 'error');
      }
    });
  }

  searchStakeholder() {
    this.displayFrom = false;
    let searched = this.searchvalue.toLowerCase();
    this.filteredstakeholders = this.stakeholders.filter((n) =>
      n.Fullname.toLowerCase().includes(searched)
    );

    console.log('Found Data ', this.filteredstakeholders);
  }

  searchEngagment() {
    this.displayFrom = false;
    let searched = this.searchEngagementvalue.toLowerCase();
    this.filteredengagements = this.engagements.filter((n) =>
      n.EngagementTitle.toLowerCase().includes(searched)
    );

    console.log('Found Data ', this.engagements);
  }

  public fullPhoneEmail(stakeholder: StakeholderDto, type: string): string {
    let phonecommaseparated: string;
    let phoneNumberArray = stakeholder.stakeholderContacts.filter(
      (n) =>
        n.contactType !== undefined &&
        n.contactType.ContactTypeName.toLowerCase().includes(type)
    );

    phoneNumberArray.map((phone) => {
      if (phonecommaseparated) {
        phonecommaseparated =
          phonecommaseparated + ',' + phone.StakeholderContactValue;
      } else {
        phonecommaseparated = phone.StakeholderContactValue;
      }
    });

    return phonecommaseparated;
  }

  selectStakeholder(stakeholder: StakeholderDto) {
    this.displayFrom = true;
    this.isNew = false;
    this.isUpdated = false;
    this.setShadowClasses();

    console.log('Reaching Select', stakeholder);
    //this.stakeholderForm.setValue(stakeholder);
    this.stakeholderForm.patchValue(stakeholder);

    this.stakeholderId = stakeholder.StakeholderId;

    //this.stakeholderForm.get("stakeholderContacts").patchValue(stakeholder.stakeholderContacts);

    let control = this.stakeholderForm.controls
      .stakeholderContacts as FormArray;
    while (control.length > 0) {
      control.removeAt(0);
    }

    if (stakeholder.hasOwnProperty('stakeholderContacts')) {
      for (const item of stakeholder.stakeholderContacts) {
        control.push(this.formBuilder.group(item));
      }
    }

    let controlPostalAddress = this.stakeholderForm.controls
      .stakeholderPostalAddresses as FormArray;
    while (controlPostalAddress.length > 0) {
      controlPostalAddress.removeAt(0);
    }

    if (stakeholder.hasOwnProperty('stakeholderPostalAddresses')) {
      for (const item of stakeholder.stakeholderPostalAddresses) {
        controlPostalAddress.push(this.formBuilder.group(item));
      }
    }

    let controlSocialMedia = this.stakeholderForm.controls
      .stakeholderSocialMedias as FormArray;
    while (controlSocialMedia.length > 0) {
      controlSocialMedia.removeAt(0);
    }

    if (stakeholder.hasOwnProperty('stakeholderSocialMedias')) {
      for (const item of stakeholder.stakeholderSocialMedias) {
        controlSocialMedia.push(this.formBuilder.group(item));
      }
    }

    let controlorganization = this.stakeholderForm.controls
      .stakeholderOrganizations as FormArray;
    while (controlorganization.length > 0) {
      controlorganization.removeAt(0);
    }

    if (stakeholder.hasOwnProperty('stakeholderOrganizations')) {
      for (const item of stakeholder.stakeholderOrganizations) {
        controlorganization.push(this.formBuilder.group(item));
      }
    }

    let controlareaofinterest = this.stakeholderForm.controls
      .stakeholderAreaOfInterests as FormArray;
    while (controlareaofinterest.length > 0) {
      controlareaofinterest.removeAt(0);
    }

    if (stakeholder.hasOwnProperty('stakeholderAreaOfInterests')) {
      for (const item of stakeholder.stakeholderAreaOfInterests) {
        controlareaofinterest.push(this.formBuilder.group(item));
      }
    }

    let controlclubs = this.stakeholderForm.controls
      .stakeholderClubs as FormArray;
    while (controlclubs.length > 0) {
      controlclubs.removeAt(0);
    }

    if (stakeholder.hasOwnProperty('stakeholderClubs')) {
      for (const item of stakeholder.stakeholderClubs) {
        controlclubs.push(this.formBuilder.group(item));
      }
    }

    let controlproperty = this.stakeholderForm.controls
      .stakeholderPropertys as FormArray;
    while (controlproperty.length > 0) {
      controlproperty.removeAt(0);
    }

    if (stakeholder.hasOwnProperty('stakeholderPropertys')) {
      for (const item of stakeholder.stakeholderPropertys) {
        controlproperty.push(this.formBuilder.group(item));
      }
    }

    //control.patchValue(stakeholder.stakeholderContacts);

    this.filteredstakeholders = [];
  }

  selectStakeholderEngagement(stakeholder: StakeholderDto) {
    console.log('Reaching Select in Engagement', stakeholder);
    //this.stakeholderForm.setValue(stakeholder);

    let contactGenId = Guid.create().toString();

    const control = this.stakeholderEngagementForm.controls
      .engagementStakeholders as FormArray;

    let checkIfStakeholderExist = control.value.find(
      (n) => n.StakeholderId === stakeholder.StakeholderId
    );

    if (checkIfStakeholderExist) {
      return;
    }

    control.insert(
      0,
      this.formBuilder.group({
        StakeholderComments: [''],
        StakeholderName: [stakeholder.Fullname],
        StakeholderInfluence: [0],

        CreatedById: [''],
        ModifiedById: [''],
        SubscriberId: [''],
        SiteId: [''],
        StakeholderId: [stakeholder.StakeholderId],
        EngagementId: [this.stakeholderEngagementId],
        EngagementStakeholderId: [contactGenId],
        id: contactGenId,
      })
    );

    this.filteredstakeholders = [];
  }

  selectEngagement(engagement: EngagementDto) {
    // this.displayFrom = true;
    // this.isNew = false;
    // this.isUpdated = false;
    // this.setShadowClasses();

    for (let businessTheme of this.businessThemes) {
      businessTheme.ischecked = false;
    }

    console.log('Reaching Select', engagement);
    //this.stakeholderForm.setValue(stakeholder);
    this.engagementModuleSpecificId = engagement.EngagementId;
    this.stakeholderEngagementForm.patchValue(engagement);

    this.stakeholderEngagementId = engagement.EngagementId;

    if (engagement.hasOwnProperty('engagementBusinessThemes')) {
      for (const theme of engagement.engagementBusinessThemes) {
        let checkInBusinessTheme = this.businessThemes.find(
          (n) => n.id === theme.BusinessThemeId
        );
        if (checkInBusinessTheme) {
          checkInBusinessTheme.ischecked = true;
        } else {
          checkInBusinessTheme.ischecked = false;
        }
      }
    }

    // this.stakeholderForm.get("stakeholderContacts").patchValue(stakeholder.stakeholderContacts);

    let control = this.stakeholderEngagementForm.controls
      .engagementStakeholders as FormArray;
    while (control.length > 0) {
      control.removeAt(0);
    }

    if (engagement.hasOwnProperty('engagementStakeholders')) {
      for (const item of engagement.engagementStakeholders) {
        control.push(this.formBuilder.group(item));
      }
    }

    let controlRep = this.stakeholderEngagementForm.controls
      .engagementThirdPartyReps as FormArray;
    while (controlRep.length > 0) {
      controlRep.removeAt(0);
    }

    if (engagement.hasOwnProperty('engagementThirdPartyReps')) {
      for (const item of engagement.engagementThirdPartyReps) {
        controlRep.push(this.formBuilder.group(item));
      }
    }

    //control.patchValue(stakeholder.stakeholderContacts);

    this.filteredengagements = [];

    this.isNewEngagement = false;

    this.isShowEngagementForm = true;
  }

  onChanges(): void {
    this.stakeholderForm.valueChanges.subscribe((val) => {
      this.valueChangedCounter += 1;

      if (this.valueChangedCounter > 2 && !this.isNew) {
        if (!this.isNew) {
          this.isUpdated = true;
          this.setShadowClasses();
        } else {
          console.log('Value Changed Content ', this.isNew);
          this.isUpdated = false;
          this.setShadowClasses();
        }
      } else {
        this.isUpdated = false;
        console.log('Value Changed Content ', this.isUpdated);
        this.setShadowClasses();
      }
    });
  }

  setShadowClasses() {
    let activityClasses = {
      update: !this.isNew,
      new: this.isNew,
      orange: this.isUpdated,
    };
    return activityClasses;
  }

  toggle(event, id) {
    console.log(' Data in Events ', event.checked);

    let businessTheme = this.businessThemes.find((n) => n.id === id);
    if (businessTheme) {
      businessTheme.ischecked = event.checked;
    }
  }
}
